export default function AutocompleteController() {
  const vm = this;
  vm.filter = _filter;
  vm.filteredItems = vm.items;

  function _filter() {
    if (!vm.searchText || vm.searchText.length === 0) {
      vm.filteredItems = vm.items;
    }
    vm.filteredItems = vm.items.filter(
      item => item[vm.itemLabelField].toLowerCase().includes(vm.searchText.toLowerCase())
    );
  }
}

AutocompleteController.$inject = [];
